/* globals $ */
import { registerClass } from 'libs/ComponentLoader'

import { PAGE_COMPONENTS_LOADED } from '_global/js/main'

import './styles.scss'

class FeaturedProducts {
  constructor (element) {
    this.$el = $(element)

    this.collection = this.$el.attr('data-collection')
    this.productCarousel = null
    this.currentPage = 0
    this.totalProducts = parseInt(this.$el.attr('data-total-products'))

    this.getCollectionData = this.getCollectionData.bind(this)

    $(document).on(PAGE_COMPONENTS_LOADED, (e) => {
      this.productCarousel = this.$el.find('.productCarousel').data('component')
      if (this.productCarousel) {
        this.productCarousel.initCarousel({
          dataPromise: this.getCollectionData
        })
      }
    })
  }

  getCollectionData () {
    this.currentPage += 1

    return new Promise((resolve, reject) => {
      $.ajax({
        url: '/collections/' + this.collection,
        data: {
          view: 'json',
          page: this.currentPage
        }
      })
        .done((data) => {
          resolve({
            results: JSON.parse(data),
            hasMore: (this.currentPage * 5) < this.totalProducts
          })
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
          reject(textStatus)
        })
    })
  }
}

registerClass('FeaturedProducts', FeaturedProducts)
